import { render, staticRenderFns } from "./SubDisposition.vue?vue&type=template&id=4d701fea"
import script from "./SubDisposition.vue?vue&type=script&lang=js"
export * from "./SubDisposition.vue?vue&type=script&lang=js"
import style0 from "./SubDisposition.vue?vue&type=style&index=0&id=4d701fea&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports